(function () {
  'use strict';

  var CONFIRMATION_HEADING = 'your order is confirmed';
  var CONFIRMATION_SUBTEXT = 'confirmation email soon';
  var ACTIVE_CLASS = 'is-visible';
  var FOCUS_CLASS = 'order-confirmation-confetti-focus';
  var CELEBRATING_CLASS = 'is-celebrating';
  var CANVAS_CLASS = 'order-confirmation-confetti-canvas';
  var COLORS = ['#F7D06B', '#F49CBB', '#84D7DB', '#FFFFFF', '#C6A25D', '#B9E2FF', '#FF7A59'];
  var SHAPES = ['rect', 'ribbon', 'circle'];

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function findConfirmationTextNode() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var text = normalize(node.nodeValue);
        if (text.indexOf(CONFIRMATION_HEADING) > -1) {
          return NodeFilter.FILTER_ACCEPT;
        }

        return NodeFilter.FILTER_SKIP;
      }
    });

    return walker.nextNode();
  }

  function findConfirmationSection() {
    var bodyText = normalize(document.body && document.body.innerText);
    if (bodyText.indexOf(CONFIRMATION_HEADING) === -1 || bodyText.indexOf(CONFIRMATION_SUBTEXT) === -1) {
      return null;
    }

    var textNode = findConfirmationTextNode();
    var element = textNode && textNode.parentElement;

    while (element && element !== document.body) {
      var elementText = normalize(element.innerText);
      if (elementText.indexOf(CONFIRMATION_HEADING) > -1 && elementText.indexOf(CONFIRMATION_SUBTEXT) > -1) {
        return element;
      }

      element = element.parentElement;
    }

    return textNode ? textNode.parentElement : null;
  }

  function random(min, max) {
    return min + Math.random() * (max - min);
  }

  function createParticle(width, height, burst) {
    var size = random(5, 12) * (window.innerWidth < 600 ? 0.82 : 1);
    var startAroundCenter = burst && Math.random() > 0.42;

    return {
      x: startAroundCenter ? random(width * 0.18, width * 0.82) : random(-40, width + 40),
      y: burst ? random(-height * 0.22, -20) : random(-height, -20),
      w: random(size * 0.45, size * 1.35),
      h: random(size * 0.55, size * 1.8),
      vx: random(-0.42, 0.42),
      vy: random(1.2, 3.7),
      gravity: random(0.008, 0.026),
      drift: random(0.8, 2.8),
      driftSpeed: random(0.009, 0.024),
      spin: random(-0.12, 0.12),
      rotation: random(0, Math.PI * 2),
      opacity: random(0.62, 0.94),
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      shape: SHAPES[Math.floor(Math.random() * SHAPES.length)],
      glow: Math.random() > 0.68,
      life: random(0.84, 1)
    };
  }

  function runConfetti(target) {
    if (prefersReducedMotion() || document.querySelector('.' + CANVAS_CLASS)) {
      return;
    }

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0;
    var height = 0;
    var particles = [];
    var startedAt = performance.now();
    var duration = 7200;
    var fadeStart = 5600;
    var animationFrame = null;

    canvas.className = CANVAS_CLASS;
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    if (target) {
      target.classList.add(FOCUS_CLASS, CELEBRATING_CLASS);
    }

    function resize() {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function seedParticles() {
      var density = width < 600 ? 58 : width < 1024 ? 82 : 118;
      var count = Math.min(density, 130);

      particles = [];
      for (var i = 0; i < count; i += 1) {
        particles.push(createParticle(width, height, true));
      }
    }

    function targetRect() {
      if (!target || !target.getBoundingClientRect) {
        return null;
      }

      var rect = target.getBoundingClientRect();
      return {
        left: rect.left - 20,
        right: rect.right + 20,
        top: rect.top - 16,
        bottom: rect.bottom + 16
      };
    }

    function drawParticle(piece, rect, elapsed) {
      var inTextZone = rect && piece.x > rect.left && piece.x < rect.right && piece.y > rect.top && piece.y < rect.bottom;
      var alpha = piece.opacity * piece.life * (inTextZone ? 0.28 : 1);

      context.save();
      context.globalAlpha = alpha;
      context.translate(piece.x, piece.y);
      context.rotate(piece.rotation);
      context.fillStyle = piece.color;

      if (piece.glow) {
        context.shadowColor = piece.color;
        context.shadowBlur = 14;
      }

      if (piece.shape === 'circle') {
        context.beginPath();
        context.arc(0, 0, piece.w * 0.55, 0, Math.PI * 2);
        context.fill();
      } else if (piece.shape === 'ribbon') {
        context.beginPath();
        context.moveTo(-piece.w / 2, -piece.h / 2);
        context.lineTo(piece.w / 2, -piece.h / 3);
        context.lineTo(piece.w * 0.34, piece.h / 2);
        context.lineTo(-piece.w / 2, piece.h / 3);
        context.closePath();
        context.fill();
      } else {
        context.fillRect(-piece.w / 2, -piece.h / 2, piece.w, piece.h);
      }

      if (elapsed < 2600 && piece.glow) {
        context.globalAlpha = alpha * 0.26;
        context.beginPath();
        context.arc(0, 0, piece.w * 1.9, 0, Math.PI * 2);
        context.fill();
      }

      context.restore();
    }

    function tick(now) {
      var elapsed = now - startedAt;
      var rect = targetRect();

      context.clearRect(0, 0, width, height);

      if (elapsed < 3200 && particles.length < 150 && Math.random() > 0.62) {
        particles.push(createParticle(width, height, false));
      }

      for (var i = particles.length - 1; i >= 0; i -= 1) {
        var piece = particles[i];
        var sway = Math.sin(elapsed * piece.driftSpeed + i) * piece.drift;

        piece.x += piece.vx + sway * 0.035;
        piece.y += piece.vy;
        piece.vy += piece.gravity;
        piece.rotation += piece.spin;

        if (elapsed > fadeStart) {
          piece.life = Math.max(0, 1 - (elapsed - fadeStart) / (duration - fadeStart));
        }

        drawParticle(piece, rect, elapsed);

        if (piece.y > height + 40 || piece.life <= 0) {
          particles.splice(i, 1);
        }
      }

      if (elapsed < duration && particles.length) {
        animationFrame = window.requestAnimationFrame(tick);
      } else {
        canvas.classList.remove(ACTIVE_CLASS);
        if (target) {
          target.classList.remove(CELEBRATING_CLASS);
        }

        window.setTimeout(function () {
          if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
          }
          canvas.remove();
        }, 1000);
      }
    }

    resize();
    seedParticles();
    window.addEventListener('resize', resize, { passive: true });

    window.requestAnimationFrame(function () {
      canvas.classList.add(ACTIVE_CLASS);
      animationFrame = window.requestAnimationFrame(tick);
    });

    window.setTimeout(function () {
      window.removeEventListener('resize', resize);
    }, duration + 1200);
  }

  function init() {
    if (!document.body) {
      return;
    }

    var section = findConfirmationSection();
    if (section) {
      window.setTimeout(function () {
        runConfetti(section);
      }, 450);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
